import { render, staticRenderFns } from "./SettingPlanPad.vue?vue&type=template&id=ef4178d4&scoped=true"
import script from "./SettingPlanPad.vue?vue&type=script&lang=js"
export * from "./SettingPlanPad.vue?vue&type=script&lang=js"
import style0 from "./SettingPlanPad.vue?vue&type=style&index=0&id=ef4178d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4178d4",
  null
  
)

export default component.exports